import { useAuth } from "@x-veloper/dataslot-auth";

export function AuthDebug() {
  const auth = useAuth();

  console.log("=== AUTH DEBUG ===", {
    hasSignInWithLine: !!auth.signInWithLine,
    hasHandleLineCallback: !!auth.handleLineCallback,
    hasGetLineAuthError: !!auth.getLineAuthError,
    allKeys: Object.keys(auth),
    signInWithLineType: typeof auth.signInWithLine
  });

  return null;
}
